export default __webpack_public_path__ + "static/patreon-logo-55cfc49d9a308156e4c06eee4f377ab8.svg";